import { Typography } from '@breetometer/components';
import { ChevronDown, FiatIcon } from 'BreetAssets';
import { CURRENCYCONFIG } from 'BreetHelpers';

import type { DropdownCurrencyControlProps } from '../../Dropdown.helpers';

export const CurrencyDropDownControl = ({ selectedItem, buttonRef, handleVisibility, visible }: DropdownCurrencyControlProps) => {
	const openClass = visible ? ' open' : '';
	const validClass = selectedItem?.currency ? ' valid' : '';

	const chevronClass = `dropdown_content_control_chevron svg-dark toggleicon${openClass}`;
	const buttonClass = `dropdown_content_control${openClass}${validClass}`;

	return (
		<button
			onClick={handleVisibility}
			className={buttonClass}
			ref={buttonRef}
			type='button'
		>
			{!!selectedItem?.currency && (
				<Typography
					as='span'
					className='dropdown_content_control_flag'
				>
					<FiatIcon
						currencyCode={selectedItem.currency}
						variant='round'
					/>
				</Typography>
			)}

			<div>
				<Typography as='label'>{selectedItem?.currency} Wallet Balance</Typography>
				{!!selectedItem?.walletBalance && (
					<Typography
						as='span'
						className='dropdown_content_control_code color-neutral-50'
					>
						{CURRENCYCONFIG[selectedItem.currency].symbol}
						{selectedItem.walletBalance}
					</Typography>
				)}
			</div>

			<ChevronDown className={chevronClass} />
		</button>
	);
};
